import React, { useState, useEffect, Fragment } from "react";
import Button from "../form/Button";
import Input from "../form/Input";
import { postData } from "../../services/api";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import { classNames } from "../../helper/classNames";
import Select from "../form/Select";
import Checkbox from "../form/Checkbox";
import { useSelector } from "react-redux";
import ConfirmationPopup from "./ConfirmationPopup";
import OtherPositionPopup from "./OtherPositionPopup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authLogin, authLogout } from "../../store/authSlice";
import { emailDomain, SuccessonPlanLimitMessage } from "../../helpers";
import TrialAlertPopup from "./TrialAlertPopup";
import { Dialog, Transition } from "@headlessui/react";
import SurveyConfirmationPopup from "./SurveyConfirmationPopup";

const InviteUserPopup = ({ isOpen, setIsOpen = () => {}, data, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isTrial = localStorage.getItem("isTrial");
  const user = useSelector((state) => state.auth?.user);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [designation, setDesignation] = useState("");
  const [assignTitle, setAssignTitle] = useState("");
  const [domain, setDomain] = useState("");
  const [filed, setField] = useState("");
  const [selectRetirementWindow, setSelectRetirementWindow] = useState("");
  const [position, setPosition] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [employeeId,setEmployeeId] = useState("");
  const [isInvitedBoardMember, setIsInvitedBoardMember] = useState(2);
  const [isAdditionalAdminDisabled, setIsAdditionalAdminDisabled] =
    useState(false);
  const [isAdditionalAdministrator, setIsAdditionalAdministrator] = useState(2);
  const [isInviteMemberDisabled, setIsInviteMemberDisabled] = useState(false);
  const [enabledOtherPositionPopup, setEnabledOtherPositionPopup] =
    useState(false);
  const [enabledConfirmationPopup, setEnabledConfirmationPopup] =
    useState(false);
  const [enabledTrialPopup, setEnabledTrialPopup] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [enabledConfirmationSurveyPopup, setEnabledConfirmationSurveyPopup] = useState(false);
  const [currentStatus,setCurrentStatus] = useState();

  const effectIsInvitedBoardMember = isInvitedBoardMember || "";
  useEffect(() => {
    async function positionData() {
      setDesignation("");
      try {
        const result = await postData("position/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          isBoardMember: isInvitedBoardMember === 1 ? 1 : 2,
        });
        if (result.data) {
          setPosition(result.data.sort((a, b) => a.name.localeCompare(b.name)));
        } else {
          console.log("Position list message", result.message);
        }
      } catch (error) {
        console.log("Error position list catch", error.message);
      }
    }
    positionData();
  }, [effectIsInvitedBoardMember]);

  const closeModal = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      setIsAdditionalAdministrator(user?.confirm_additional_admin);
      if (user?.confirm_additional_admin === 1) {
        setIsAdditionalAdminDisabled(false);
        setIsInviteMemberDisabled(true);
      }
    }
  }, [user]);

  useEffect(() => {
    async function employeeData() {
      try {
        const result = await postData("employee/list", {
          sortQuery: { created_at: -1 },
          status: 1,
        });
        
        if (result.data) {
          setEmployees(
            result.data.map((items) => {
                let firstName = "";
                let lastName = "";
                
                if (!items?.first_name) {
                  firstName = items?.name.split(/\s+/)[0];
                  lastName = items?.name.split(/\s+/)[1];
                } else {
                  firstName = items?.first_name;
                  lastName = items?.last_name;
                }
                
                return {
                  ...items,
                  first_name: firstName,
                  last_name: lastName,
                };
              }).filter((it) => it?.role_details?.code !== "customer-admin") // Corrected filter
          );
        } else {
          console.log("Employee list message", result.message);
        }
      } catch (error) {
        console.log("Error employee list catch", error.message);
      }
    }
    
    employeeData();
  }, []);


  const onSubmit = async () => {
    let successionPlanCount = 0;
    let totalSuccessionPlan = user?.number_of_succession_plan
      ? user?.number_of_succession_plan
      : 0;
    if (user?.features && user?.features?.length > 0) {
      successionPlanCount = user?.features?.find(
        (it) => it?.code === "succession-plans-per-year"
      )?.inputValue;
    }
    if (successionPlanCount && successionPlanCount > totalSuccessionPlan) {
      try {
        let payload;
        let path;
        if (id) {
          path = "assign/update";
          payload = {
            id: id,
            name: name,
            title: assignTitle,
            email: email + "@" + domain,
            company_name: user?.company_name,
          };
        } else {
          path = "assign/create";
          payload = {
            name: name,
            title: assignTitle,
            email: email,
            //email: email+'@'+domain,
            designation: designation,
            retirement_window: selectRetirementWindow,
            company_name: user?.company_name,
            isInvitedBoardMember: isInvitedBoardMember,
          };
        }
        const result = await postData(path, payload);
        if (result.status && result.status === 200) {
          toastr.success(result.message);
          setLoading(false);
          setName("");
          setAssignTitle("");
          setEmail("");
          setDesignation("");
          setSelectRetirementWindow("");
          const userData = await postData(
            "verify-token",
            {},
            localStorage.getItem("accessToken")
          );
          if (userData?.data) {
            if (userData?.status && userData?.status === 200) {
              dispatch(authLogin(userData?.data));
            } else {
              dispatch(authLogout());
              localStorage.removeItem("accessToken");
              navigate("/signin");
            }
          }
          setEnabledConfirmationSurveyPopup(true);
          // return navigate("/dashboard");
        } else {
          toastr.error(result.message);
          setLoading(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setLoading(false);
      }
    } else {
      toastr.error(SuccessonPlanLimitMessage(successionPlanCount));
      setLoading(false);
    }
  };
  useEffect(() => {
    if (
      actionValue &&
      (actionValue.button_type === "confirm" ||
        actionValue.button_type === "close")
    ) {
      let fieldValue = 0;
      if (actionValue.button_type === "confirm") {
        fieldValue = 1;
      } else if (actionValue.button_type === "close") {
        fieldValue = 2;
      }
      const confirmAdditionalAdministrator = async () => {
        setLoading(true);
        try {
          const result = await postData("permission/manage", {
            [filed]: fieldValue,
          });
          if (result.data) {
            dispatch(
              authLogin({
                ...user,
                confirm_additional_admin: fieldValue,
              })
            );
            toastr.success(result.message);
            if (actionValue.button_type === "confirm") {
              setIsAdditionalAdministrator(1);
              setIsInvitedBoardMember(2);
              if (fieldValue === 1) {
                setIsAdditionalAdminDisabled(false);
                setIsInviteMemberDisabled(true);
              } else {
                setIsAdditionalAdminDisabled(false);
                setIsInviteMemberDisabled(false);
              }
            } else if (actionValue.button_type === "close") {
              setIsAdditionalAdministrator(2);
              setIsInvitedBoardMember(2);
              setIsAdditionalAdminDisabled(false);
              setIsInviteMemberDisabled(false);
            }
            setEnabledConfirmationPopup(false);
          }
          setLoading(false);
        } catch (err) {
          setLoading(false);
          console.log(err.message);
        }
      };
      confirmAdditionalAdministrator();
    }else if(actionValue && actionValue.button_type === "confirmation-survay"){
      if (actionValue.current_status === 2) {
        closeModal();
      }
    } else if (actionValue) {
      if(actionValue.button_type !== 'other-position-close'){
        setPosition([...position, actionValue]);
      } 
      setDesignation(actionValue?._id);
    }
  }, [actionValue]);

  useEffect(() => {
    if (user && Object.keys(actionValue).length === 0) {
      setDesignation(user?.designation);
      setDomain(emailDomain(user?.email));
    }
  }, [user, position, actionValue]);

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-4xl transform rounded-2xl bg-white p-4 text-left align-middle shadow-xl transition-all">
                  {/* <div className="relative bg-gradient-to-r from-teal-500 to-teal-600 text-white p-6 rounded-t-2xl"> */}
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 text-center">
                      {t("invite_individuals_in_your_company")}
                    </Dialog.Title>
                    <div className="absolute top-2 right-2 z-10">
                      <Button
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={"fa-light fa-times"}
                        buttonIconPosition={"left"}
                        buttonLabel={""}
                        buttonClasses={
                          "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"
                        }
                        functions={() => {
                          closeModal();
                        }}
                        buttonHasLink={false}
                      />
                    </div>
                  {/* </div> */}
                  <div className="relative mt-4">
                    <div className="space-y-4 px-2 py-2 mt-3">
                      <div className="relative space-y-2">
                        <div className="relative w-full mt-1">
                          <Select
                            //requiredDisplay={true}
                            label={t("company_employees")}
                            labelClasses={"!text-xs"}
                            xPlacement={"left"}
                            selectedValue={employeeId}
                            dropdownClass={"!w-full"}
                            search={true}
                            //transitionClass={"!left-0"}
                            dropdownData={[
                              { _id: "", label: t("select"), value: "" },
                              ...employees.map((item) => ({
                                _id: item?._id,
                                label: item?.first_name + " " + item?.last_name,
                                value: item?.email,
                                position: item?.designation,
                              })),
                            ].filter((item) => item)}
                            getSelectedValue={(e) => {
                              setEmployeeId(e._id);
                              setName((e._id)?e.label:"");
                              setEmail(e.value);
                              setDesignation(e.position);
                            }}
                          />
                        </div>
                        <div className="relative w-full mt-1">
                          <Input
                            label={t("full_name") + ":"}
                            requiredDisplay={true}
                            labelClasses={"!text-xs"}
                            inputType={"text"}
                            inputPlaceholder={t("enter_full_name")}
                            inputValue={name}
                            setInput={setName}
                          />
                        </div>
                        <div className="relative w-full mt-1">
                          <Input
                            label={t("work_email") + ":"}
                            requiredDisplay={true}
                            labelClasses={"!text-xs"}
                            inputType={"email"}
                            inputPlaceholder={t("work_email_address")}
                            inputValue={email}
                            setInput={setEmail}
                          />
                          {/* <InputGroup
                        label={"Work Email"}
                        labelClasses={"!text-xs"}
                        inputType={"email"}
                        inputPlaceholder={"Work Email Address"}
                        inputValue={email}
                        setInput={setEmail}
                        getSuffix={'@'+domain}
                        errorType={'info'}
                        errorText={'Only use email prefix'}
                      /> */}
                        </div>
                        {!id && (
                          <>
                            <div className="relative w-full mt-1">
                              <Select
                                label={
                                  t(
                                    "position_the_succession_plan_is_being_created_by"
                                  ) + ":"
                                }
                                requiredDisplay={true}
                                labelClasses={"!text-xs"}
                                xPlacement={"left"}
                                selectedValue={designation}
                                dropdownClass={"!w-full"}
                                search={true}
                                dropdownData={[
                                  {
                                    _id: "",
                                    label: t("select_position"),
                                    value: "",
                                  },
                                  ...position.map((item) => ({
                                    _id: item?._id,
                                    label: item?.name,
                                    value: item?._id,
                                  })),
                                  {
                                    _id: "others",
                                    label: "Other",
                                    value: "others",
                                  },
                                ].filter((itm) => itm)}
                                getSelectedValue={(e) => {
                                  if (e._id === "others") {
                                    setEnabledOtherPositionPopup(true);
                                  }
                                  setDesignation(e._id);
                                }}
                              />
                            </div>
                          </>
                        )}
                        <div className="relative w-full mt-2">
                          <Checkbox
                            checkboxLabel={t("create_additional_administrator")}
                            checkboxLableClass={""}
                            isChecked={
                              isAdditionalAdministrator &&
                              isAdditionalAdministrator === 1
                                ? true
                                : false
                            }
                            checkboxValue={"confirm_additional_admin"}
                            getCheckboxValue={(code, event) => {
                              if (event.target.checked === true) {
                                setEnabledConfirmationPopup(true);
                              } else {
                                setActionValue({
                                  button_type: "close",
                                  row_id: "",
                                  current_status: "",
                                });
                                setIsAdditionalAdminDisabled(false);
                                setIsInviteMemberDisabled(false);
                              }
                              setField(code);
                            }}
                            isDisabled={isAdditionalAdminDisabled}
                          />
                        </div>
                        <div className="relative w-full mt-2">
                          <Checkbox
                            checkboxLabel={t("invite_board_member")}
                            checkboxLableClass={""}
                            isChecked={
                              isInvitedBoardMember && isInvitedBoardMember === 1
                                ? true
                                : false
                            }
                            checkboxValue={"invite_additional_member"}
                            getCheckboxValue={(code, event) => {
                              if (event.target.checked === true) {
                                setIsInvitedBoardMember(1);
                                setIsAdditionalAdminDisabled(true);
                                setIsInviteMemberDisabled(false);
                                //setEnabledConfirmationPopup(true)
                              } else {
                                setIsInvitedBoardMember(2);
                                setIsAdditionalAdminDisabled(false);
                                setIsInviteMemberDisabled(false);
                              }
                              setField(code);
                            }}
                            isDisabled={isInviteMemberDisabled}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="relative flex justify-center mt-2 gap-4">
                      {isTrial !== 1 ? (
                        <Button
                          buttonClasses=""
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : "fa-light fa-check"
                          }
                          buttonIconPosition={"left"}
                          buttonLabel={t("invite")}
                          functions={onSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      ) : (
                        <Button
                          buttonClasses={
                            "!bg-slate-200 !text-slate-600 border border-slate-300"
                          }
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={"fa-light fa-check"}
                          buttonIconPosition={"left"}
                          buttonLabel={t("invite")}
                          buttonHasLink={false}
                          functions={() => {
                            setEnabledTrialPopup(true);
                          }}
                        />
                      )}
                      <Button
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={"fa-light fa-times"}
                        buttonIconPosition={"left"}
                        buttonLabel={t("cancel")}
                        buttonClasses={
                          "!bg-slate-200 !text-slate-600 border border-slate-300"
                        }
                        functions={closeModal}
                        buttonHasLink={false}
                      />
                    </div>
                    {enabledOtherPositionPopup && (
                      <OtherPositionPopup
                        isOpen={enabledOtherPositionPopup}
                        setIsOpen={(val) => setEnabledOtherPositionPopup(val)}
                        data={{
                          isBoardMember: isInvitedBoardMember
                        }}
                        getActionValue={(obj) => {
                          setActionValue(obj);
                        }}
                      />
                    )}
                    {enabledConfirmationPopup && (
                      <ConfirmationPopup
                        isOpen={enabledConfirmationPopup}
                        title={"Confirmation"}
                        message={
                          "By checking this box you will allow the user administrator access to all plans and information within the company account."
                        }
                        confirmButtonLabel={"Confirm Additional Admin"}
                        cancelButtonLabel={"Decline"}
                        setIsOpen={(val) => setEnabledConfirmationPopup(val)}
                        getActionValue={(obj) => {
                          //updateHandler(currentId,false)
                          setActionValue(obj);
                        }}
                      />
                    )}
                    {enabledTrialPopup && (
                      <TrialAlertPopup
                        isOpen={enabledTrialPopup}
                        setIsOpen={(val) => setEnabledTrialPopup(val)}
                        getActionValue={(obj) => {
                          setActionValue(obj);
                        }}
                      />
                    )}
                    {enabledConfirmationSurveyPopup && (
                      <SurveyConfirmationPopup
                        isOpen={enabledConfirmationSurveyPopup}
                        setIsOpen={(val) => setEnabledConfirmationSurveyPopup(val)}
                        getActionValue={(obj) => {
                          setActionValue(obj);
                        }}
                        message={'Do you want to invite additional users?'}
                      ></SurveyConfirmationPopup>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default InviteUserPopup;
